<template>
  <div> 
    <div
      class="google-map"
      ref="googleMap"
    ></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
      />
    </template>
  </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
  props: {
    mapConfig: Object,
    apiKey: String,
    bondMarkers: Object,
    language: String
  },

  data() {
    return {
      google: null,
      map: null,
      bounds: null
    };
  },

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,
      language: this.language
    });
    this.google = googleMapApi;
    this.initializeMap();
  },

  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMap;
      this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
      if(Object.keys(this.bondMarkers).length > '1'){
        this.bounds = new this.google.maps.LatLngBounds();
        for (var i = 0; i < Object.keys(this.bondMarkers).length; i++) { 
          this.bounds.extend(this.bondMarkers[i].position);
        }
        //this.map.fitBounds(this.bounds);  
        this.$nextTick(() => {
          this.map.fitBounds(this.bounds);
        });
      }
    }
  }
};
</script>

<style scoped>
.google-map {
  width: 100%;
  min-height: 100%;
}
</style>
